module.exports = global["jQuery"] = require("-!/var/www/html/node_modules/jquery/dist/jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?jQuery!./~/jquery/dist/jquery.js
// module id = 1742
// module chunks = 1